<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="600" persistent scrollable>
    <v-card dark>
      <v-card-title>
        <v-icon left>mdi-pencil</v-icon>
        Bewerbung bearbeiten
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog" :disabled="isSaving"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="pt-4" style="max-height: 70vh">
        <v-form ref="editForm" @submit.prevent="saveApplication">
          <v-row dense>
            <v-col cols="12" sm="6">
              <v-text-field v-model="formData.firstName" label="Vorname" outlined dense required></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="formData.lastName" label="Nachname" outlined dense required></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="formData.email" label="E-Mail" type="email" outlined dense></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="formData.phone" label="Telefon" outlined dense></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="formData.desiredWorkload" label="Gewünschtes Pensum (z.B. 80-100%)" outlined dense></v-text-field>
            </v-col>

            <v-col cols="12" class="mt-2">
              <h4 class="mb-2 grey--text text--lighten-1">Adresse</h4>
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="formData.address.street" label="Strasse & Hausnummer" outlined dense></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field v-model="formData.address.zip" label="PLZ" outlined dense></v-text-field>
            </v-col>
            <v-col cols="12" sm="8">
              <v-text-field v-model="formData.address.city" label="Ort" outlined dense></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog" :disabled="isSaving">Abbrechen</v-btn>
        <v-btn color="primary" @click="saveApplication" :loading="isSaving">Speichern</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/api"

export default {
  name: "JobApplicationEditDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    application: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isSaving: false,
      formData: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        desiredWorkload: "",
        address: {
          street: "",
          zip: "",
          city: "",
        },
      },
    }
  },
  watch: {
    value(isOpen) {
      if (isOpen && this.application) {
        this.initializeForm()
      }
    },
  },
  methods: {
    initializeForm() {
      this.formData = {
        firstName: this.application.firstName || "",
        lastName: this.application.lastName || "",
        email: this.application.email || "",
        phone: this.application.phone || "",
        desiredWorkload: this.application.desiredWorkload || "",
        address: {
          street: this.application.address?.street || "",
          zip: this.application.address?.zip || "",
          city: this.application.address?.city || "",
        },
      }
    },
    closeDialog() {
      this.$emit("input", false)
    },
    async saveApplication() {
      this.isSaving = true
      try {
        const updatedApplication = await api.jobApplications.update(this.application._id, this.formData)
        if (this.$toast) this.$toast.success("Bewerbung erfolgreich aktualisiert")
        this.$emit("saved", updatedApplication)
      } catch (error) {
        console.error("Fehler beim Speichern:", error)
        if (this.$toast) this.$toast.error("Bewerbung konnte nicht gespeichert werden")
      } finally {
        this.isSaving = false
      }
    },
  },
  mounted() {
    if (this.value) this.initializeForm()
  },
}
</script>
